import { en as coreEn } from '@account-services-mfe/core';
const en = {
    translation: {
        ...coreEn.translation,
        alreadyEnrolled: {
            header: {
                title: 'You’ve purchased Payment Security'
            },
            howCanICancel: {
                body: 'Payment Security is optional and you can cancel at any time by calling 800-815-4051 or by <managePaymentSecurityLink>{{linkText}}</managePaymentSecurityLink>.',
                linkText: 'managing Payment Security',
                title: 'How can I cancel'
            }
        },
        cancelled: {
            errorMessage: {
                description: 'You can still use your Payment Security benefits as long as your qualifying event took place before you cancelled.',
                title: 'You’ve cancelled your Payment Security'
            },
            header: {
                title: 'With Payment Security, get protected in the event of the unexpected'
            }
        },
        common: {
            agreementCheck: 'Yes, I would like to <strong>purchase the optional</strong> Payment Security product. I have read and agree to the terms of the Payment Security Debt Cancellation Program Agreement. Checking this box qualifies as my electronic signature.',
            coverageAfterSignupDate: 'You’re covered for most qualifying events right away, as long as they occur after your purchase date. For a job loss or leave of absence, coverage starts 30 days after purchase.',
            coverMinimumPayments: 'Payment Security can cover your minimum payments or your entire credit balance up to $10,000 after certain life events.',
            disability: 'Disability',
            header: {
                subtitle: 'Your account balance up to $10,000 may be cancelled.'
            },
            hospitalization: 'Hospitalization',
            howMuchItCosts: 'How much it costs',
            lastStatementBalance: '$1.66 per $100 of your last statement balance. For example, if you had a $500 balance, you’d pay $8.30.',
            leaveOfAbsence: 'Leave of absence',
            lossOfLife: 'Loss of life',
            nursingHomeStay: 'Nursing home stay',
            paymentCancellationAndRefund: 'It’s optional, and you can cancel anytime. If you cancel within 90 days, we’ll refund the Payment Security fees you’ve paid so far.',
            paymentSecurityCancellationAgreement: 'Read the <cancellationAgreementLink>{{cancellationAgreementText}}</cancellationAgreementLink>.',
            cancellationAgreementText: 'Payment Security Debt Cancellation Program Agreement',
            paymentSecurityDetails: 'Payment Security Details',
            qualifiesAsAnEvent: 'What qualifies as an event',
            unemployment: 'Unemployment',
            whatItProvides: 'What it provides'
        },
        deniedEnrollment: {
            title: 'You’re unable to purchase Payment Security at this time'
        },
        enrollmentSuccess: {
            chargesStatement: 'You’ll see the charges for Payment Security starting with your next statement. You can cancel at any time. If you cancel within 90 days of your purchase, we’ll credit your account for any Payment Security fees charged.',
            requestOnProcess: 'We are processing your request which may take up to 72 hours to process.',
            thanksForPurchasing: 'Thank you for purchasing Payment Security'
        },
        errorMessages: {
            termsAgreement: 'Check the box to agree to these terms and continue'
        },
        footer: {
            backToAccountServices: 'back to account services',
            close: 'close',
            managePaymentSecurity: 'manage payment security',
            purchasePaymentSecurity: 'purchase payment security'
        },
        notEnrolled: {
            header: {
                title: 'With Payment Security, get protected in the event of the unexpected'
            },
            whatToKnow: {
                authorize: 'You authorize the program costs, calculated at $1.66 per $100 of your last statement balance, to be billed to your account each month, effective immediately.',
                beginAfter: 'All events must begin after you enroll in the program; for a job loss or leave of absence, you must have been enrolled for 30 days prior to occurrence.',
                cancelAnytime: 'You may cancel at anytime. If you cancel within 90 days, you’ll receive a full refund.',
                fullTime: 'You must have a full-time, year-round job to qualify for full balance cancellation.',
                jobLossAndLeave: 'Job loss and leave of absence benefits depend on your job type:',
                partTime: 'Self-employed, seasonal or part-time jobs only qualify for cancellation up to 6 months of minimum payments.',
                title: 'What to know',
                understandProgramFee: 'You understand the program fee will appear on your statement every month and will be charged even if you pay your statement balance in full.'
            }
        },
        pendingEnrollment: {
            paymentRequestReceived: 'We’ve received your request for Payment Security',
            statusUpdate: 'Your status will be updated within 3 days.'
        },
        crossBorder: {
            title: 'Opening a new browser tab',
            body: `We're opening a new tab where you can manage your Payment Security benefits.`,
            openNewTabButton: 'Yes, open in a new tab',
            goBackButton: 'No, go back'
        }
    }
};
export default en;
